import { useEffect, useState } from 'react';

// One read-only clock shared by mounted operational surfaces.
const listeners = new Set();
let timer;
export default function useOperationalClock() {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    listeners.add(setNow);
    if (!timer) timer = setInterval(() => {
      const instant = Date.now();
      listeners.forEach(update => update(instant));
    }, 1000);
    return () => {
      listeners.delete(setNow);
      if (!listeners.size) { clearInterval(timer); timer = undefined; }
    };
  }, []);
  return now;
}
